module.exports = {
	"language": "pl",
	"title": "FBC Czasopisma",
	"langs": {
		"pl": "Polski",
		"en": "English"
	},
	"go_top": "Idź do góry",
	"fonts": {
		"name": {
			"default": "domyślna",
			"medium": "średnia",
			"big": "duża"
		}
	},
	"search": {
		"form": {
			"select": {
				"params": {
					"param_1": {
						"name": "Tytuł lub słowa kluczowe",
						"val": "",
						"autocomplete": "suggest_main"
					},
					"param_2": {
						"name": "Tytuł",
						"val": "title_for_search",
						"autocomplete": "suggest_newspaper_title"
					},
					"param_3": {
						"name": "Słowa kluczowe",
						"val": "subject",
						"autocomplete": "suggest_subject"
					}
				}
			},
			"input": {
				"placeholder": "Podaj frazę do wyszukania"
			},
			"button": {
				"search": "Szukaj"
			}
		},
		"results": {
			"title": "Czasopisma",
			"no_results": "Brak wyników"
		},
		"info": {
			"title": "Wyniki",
			"count": "Liczba czasopism",
			"clear": "Wyczyść zapytanie"
		},
		"main": {
			"desc": "Czasopisma ze zbiorów polskich instytucji kultury i nauki"
		}
	},
	"pagination": {
		"next": "Następna",
		"prev": "Poprzednia",
		"next_page": "Następna strona",
		"prev_page": "Poprzednia strona",
		"from_pages": "z"
	},
	"sorting": {
		"params": {
			"relevance": {
				"name": "Sortuj wg trafności",
				"val": ""
			},
			"title": {
				"name": "Sortuj wg tytułu (alfabetycznie)",
				"val": "newspaper_title%20asc"
			},
			"date_desc": {
				"name": "Sortuj wg daty wydania - od najnowszego numeru",
				"val": "date_start%20asc"
			},
			"date_asc": {
				"name": "Sortuj wg daty wydania - od najstarszego numeru",
				"val": "date_end%20desc"
			}
		}
	},
	"items_per_page": {
		"label": "wyników na stronie",
		"elems": {
			"first": {
				"name": "trzydziesci",
				"val": 30
			},
			"second": {
				"name": "sześćdziesiąt",
				"val": 60
			},
			"third": {
				"name": "dziewięćdziesiąt",
				"val": 90
			}
		}
	},
	"filters": {
		"title": "Filtry",
		"choose": "Wybierz filtry",
		"select_all": "Zaznacz wszystkie",
		"deselect_all": "Wyczyść zaznaczone",
		"submit": "Zastosuj",
		"reset": "Resetuj filtry",
		"back": "Wróć",
		"add": "Dodaj filtr",
		"clean": "Wyczyść filtry",
		"close": "Zamknij filtry",
		"clear": "Wyczyść filtr",
		"clear_all": "Wyczyść wszystkie filtry",
		"search": {
			"placeholder": "Wpisz pierwszą literę lub szukaną frazę"
		},
		"date": {
			"reset": "Resetuj daty",
			"from": "Od",
			"to": "Do",
			"placeholder": "Wpisz rok lub miesiąc i rok lub pełną datę albo skorzystaj z listy dat poniżej.",
			"total_number": "Łączna liczba czasopism",
			"not_valid": "Podana data nie jest poprawna."
		},
		"emptylist": "Brak dopasowań. Zmień wprowadzoną frazę."
	},
	"langCode": {
		"akk": "akadyjski",
		"gwi": "gwich'in",
		"eka": "ekajuk",
		"nde": "ndebele północny (Zimbabwe)",
		"sve": "serili",
		"ijo": "ijo",
		"aka": "akan",
		"yid": "jidysz",
		"sux": "sumeryjski",
		"uig": "ujgurski",
		"ton": "tongijski",
		"sus": "susu",
		"mis": "różne języki",
		"por": "portugalski",
		"loz": "lozi",
		"tog": "tonga (Malawi)",
		"poo": "central pomo",
		"sun": "sundajski",
		"zbl": "Bliss-Symbol (język sztuczny)",
		"pon": "ponape",
		"min": "minangkabau",
		"pol": "polski",
		"suk": "sukuma",
		"kut": "kutenai",
		"lol": "mongo-nkundu",
		"mic": "micmac",
		"kur": "kurdyjski",
		"iii": "yi syczuański (nuosu)",
		"kum": "kumycki",
		"hol": "holu",
		"nbl": "ndebele południowy (RPA)",
		"zap": "zapoteckie",
		"ain": "ajnoski (ajnu)",
		"cus": "kuszyckie (inne)",
		"guj": "gudźarati",
		"kua": "kwanyama",
		"doi": "dogri",
		"jbo": "lojban (język sztuczny)",
		"zza": "zazaki",
		"oto": "otomi-mangue, języki (otomang)",
		"rar": "rarotonga",
		"vai": "vai",
		"rap": "rapanui",
		"nav": "nawaho",
		"nau": "nauru",
		"raj": "rajasthani",
		"nzi": "nzema",
		"ota": "turecko-osmański (1500-1928)",
		"ssw": "suazi",
		"nap": "neapolitański",
		"jav": "jawajski",
		"uga": "ugarycki",
		"tmh": "tamaszek (tuareski)",
		"nai": "Indian północnoamerykańskich (inne)",
		"nah": "nahuatl",
		"oss": "osetyjski",
		"fat": "fante",
		"fas": "perski",
		"egy": "egipski starożytny",
		"fao": "farerski",
		"zxx": "dokument nietekstowy",
		"fan": "fang",
		"ssa": "nilo-saharyjskie (inne)",
		"bat": "bałtyckie (inne)",
		"mga": "średnioirlandzki (1100-1550)",
		"bas": "basa",
		"nyo": "nyoro",
		"nyn": "nyankole",
		"gsw": "niemiecki szwajcarski",
		"hmo": "hiri motu",
		"nym": "nyamwezi",
		"hmn": "hmong",
		"ban": "balijski",
		"bam": "bambara",
		"osa": "osage",
		"bal": "beludżyjski",
		"hmj": "gejia",
		"bak": "baszkirski",
		"bai": "bamileke, języki",
		"srr": "serer",
		"tli": "tlingit",
		"srp": "serbski",
		"tlh": "klingoński (język sztuczny)",
		"nya": "nyanja",
		"bad": "banda, języki",
		"srn": "sranan tongo (surinamski)",
		"pli": "pali",
		"orm": "oromo",
		"srd": "sardyński",
		"kru": "kurukh",
		"byn": "bilin",
		"ori": "orija",
		"csb": "kaszubski",
		"kro": "kru, języki (inne)",
		"krl": "karelski",
		"grt": "garo",
		"tkl": "tokelau",
		"afr": "afrykanerski",
		"efi": "efik",
		"grn": "guarani",
		"mes": "masmaje",
		"krc": "karaczajsko-bałkarski",
		"men": "mende",
		"crp": "kreolskie i pidżynowe (inne)",
		"afh": "afrihili (język sztuczny)",
		"sqi": "albański",
		"grc": "grecki starożytny (starogrecki) (do 1453)",
		"grb": "grebo",
		"afa": "afroazjatyckie (inne)",
		"crh": "krymskotatarski",
		"cre": "kri",
		"udm": "udmurcki (wotiacki)",
		"nwc": "newarski klasyczny",
		"mdr": "mandarski",
		"ido": "ido",
		"mdf": "moksza",
		"spa": "hiszpański",
		"tiv": "tiw",
		"ady": "adygejski",
		"tir": "tigrinia",
		"zun": "zuni",
		"zul": "zulu",
		"wol": "wolof",
		"sot": "sotho południowy",
		"kpe": "kpelle",
		"tig": "tigre",
		"son": "songhaj",
		"som": "somalijski",
		"cpp": "kreolskie i pidżynowe na bazie języka portugalskiego (inne)",
		"rus": "rosyjski",
		"lit": "litewski",
		"rup": "arumuński",
		"sog": "sogdyjski",
		"run": "rundi",
		"lin": "lingala",
		"ada": "adangme",
		"lim": "limburski",
		"cpf": "kreolskie i pidżynowe na bazie języka francuskiego (inne)",
		"hit": "hetycki",
		"kos": "kusajski (kosrae)",
		"xho": "xhosa (khosa)",
		"cpe": "kreolskie i pidżynowe na bazie języka angielskiego (inne)",
		"kor": "koreański",
		"kon": "kongo",
		"hin": "hindi",
		"kom": "komi",
		"div": "malediwski (divehi)",
		"him": "pahari zachodnie, języki (himachali)",
		"got": "gocki",
		"hil": "hiligaynon",
		"kok": "konkani",
		"gor": "gorontalo",
		"gon": "gondi",
		"din": "dinka",
		"nub": "nubijskie",
		"cos": "korsykański",
		"fur": "friulski",
		"cor": "kornijski (kornwalijski)",
		"phn": "fenicki",
		"goh": "staro-wysoko-niemiecki (ok.750-1050)",
		"cop": "koptyjski",
		"snk": "soninke",
		"ach": "aczoli",
		"yap": "japski",
		"tha": "tajski (syjamski)",
		"yao": "yao (Afryka)",
		"ful": "fulani",
		"phi": "filipińskie (inne)",
		"ace": "Achinese",
		"ibo": "igbo",
		"snd": "sindhi",
		"sna": "szona",
		"bul": "bułgarski",
		"uzb": "uzbecki",
		"bug": "bugijski",
		"iba": "iban",
		"tgl": "tagalog (tagalski)",
		"bua": "buriacki",
		"sms": "lapoński skolt",
		"tgk": "tadżycki",
		"ebg": "ebughu",
		"mas": "masajski",
		"mar": "marathi",
		"smo": "samoański",
		"map": "austronezyjskie (malajo-polinezyjskie) (inne)",
		"smn": "lapoński inari",
		"abk": "abchaski",
		"mao": "maoryjski",
		"man": "mandingo",
		"mal": "malajalam",
		"smj": "lapoński lule",
		"mak": "makasarski",
		"smi": "lapońskie (inne)",
		"mai": "maithili",
		"mah": "marszalski",
		"mag": "magadhi",
		"sme": "lapoński północny",
		"mad": "madurski",
		"sma": "lapoński południowy",
		"btk": "batackie (Indonezja)",
		"nso": "sotho północny",
		"myv": "erzja",
		"wln": "waloński",
		"slv": "słoweński",
		"dgr": "dogrib",
		"aar": "afar",
		"myn": "majańskie",
		"aze": "azerbejdżański",
		"kmb": "kimbundu",
		"gmh": "średnio-wysoko-niemiecki (ok. 1050-1500)",
		"slk": "słowacki",
		"cmn": "mandaryński",
		"sli": "dolnośląski ",
		"mya": "birmański",
		"sla": "słowiańskie (inne)",
		"cmc": "czamskie",
		"tet": "tetum",
		"glv": "mański (manx)",
		"ter": "tereno",
		"aym": "ajmara",
		"fry": "fryzyjski",
		"tem": "temne",
		"tel": "telugu",
		"lez": "lezgiński",
		"frs": "fryzyjski, wschodni",
		"frr": "fryzyjski, północny",
		"peo": "staroperski (ok. 600-400 p.n.e.)",
		"fro": "starofrancuski (ok. 842-1300)",
		"glg": "galicyjski",
		"let": "lesing-gelimi",
		"frm": "średniofrancuski (ok. 1300-1600)",
		"gle": "irlandzki",
		"ski": "Sika",
		"jrb": "judeo-arabski",
		"gla": "gaelicki (szkocki)",
		"her": "herero",
		"nqo": "n'ko",
		"fra": "francuski",
		"deu": "niemiecki",
		"mwr": "marwari",
		"bre": "bretoński",
		"bra": "bradź",
		"mwl": "mirandyjski",
		"den": "niewolnicze (atapaskańskie)",
		"del": "delaware",
		"heb": "hebrajski",
		"ewo": "ewondo",
		"oji": "odżibwa",
		"ewe": "ewe",
		"jpr": "judeo-perski",
		"vot": "wocki",
		"sit": "chińsko-tybetańskie (inne)",
		"jpn": "japoński",
		"sio": "siouańskie (języki Siuksów) (inne)",
		"sin": "syngaleski",
		"vol": "volapück",
		"awa": "awadhi",
		"ron": "rumuński",
		"rom": "romani (cygański)",
		"sid": "sidamo",
		"nor": "norweski",
		"kir": "kirgiski",
		"roh": "retoromański (romansz)",
		"avt": "au",
		"non": "staronordyjski",
		"kin": "kinyarwanda",
		"mus": "creek (muskogi)",
		"kik": "kikuju",
		"roa": "romańskie (inne)",
		"nog": "nogajski",
		"mun": "mundajskie (inne)",
		"que": "keczua",
		"mul": "wiele języków",
		"gil": "gilbertański",
		"nob": "norweski bokmål",
		"ave": "awestyjski",
		"shn": "szan",
		"znd": "zande, języki",
		"ava": "awarski",
		"fon": "fon",
		"eus": "baskijski",
		"bos": "bośniacki",
		"aus": "australijskie",
		"nno": "norweski nynorsk",
		"xal": "ojracki (kałmucki)",
		"kho": "chotański",
		"tat": "tatarski",
		"khm": "khmerski",
		"boh": "boma",
		"khi": "khoisan, języki (inne)",
		"bod": "tybetański",
		"tam": "tamilski",
		"chy": "cheyenne",
		"pau": "palau",
		"chv": "czuwaski",
		"tai": "tajskie (inne)",
		"chu": "staro-cerkiewno-słowiański",
		"tah": "tahitański",
		"pap": "papiamento",
		"kha": "khasi",
		"sgn": "migowe, języki",
		"chr": "czirokeski",
		"pan": "pendżabski",
		"lav": "łotewski",
		"pam": "pampangan",
		"chp": "chipewyan",
		"pal": "pahlawi",
		"lat": "łaciński",
		"cho": "choctaw",
		"chn": "chinook jargon",
		"chm": "maryjski (czeremiski)",
		"bnt": "bantu (inne)",
		"tyv": "tuwiński",
		"chk": "czukocki",
		"pag": "pangasinan",
		"lao": "laotański",
		"haw": "hawajski",
		"lam": "lamba (Zambia i Kongo)",
		"hau": "hausa",
		"chg": "czagatajski",
		"hat": "haitański",
		"sga": "staroirlandzki (do 1100)",
		"che": "czeczeński",
		"paa": "papuaskie (inne)",
		"lah": "lahnda",
		"ita": "włoski",
		"day": "dajackie",
		"chb": "czibczańskie",
		"cha": "czamorro",
		"dzo": "dzongka",
		"lad": "ladino",
		"lac": "lacandon",
		"hai": "haida",
		"dar": "dargwijski",
		"ath": "atapaskańskie (inne)",
		"dan": "duński",
		"dak": "dakota",
		"isl": "islandzki",
		"est": "estoński",
		"msa": "malajski",
		"dyu": "dyula",
		"ast": "asturyjski",
		"urd": "urdu",
		"hye": "ormiański",
		"asm": "assamski",
		"wen": "łużyckie (inne)",
		"wel": "walijski",
		"nld": "niderlandzki",
		"ser": "serrano",
		"sem": "semickie (inne)",
		"iro": "irokeskie (inne)",
		"sel": "selkupski",
		"arw": "arawaskie",
		"aru": "arawá",
		"gez": "ge'ez (gyyz)",
		"art": "sztuczne (inne)",
		"ira": "irańskie (inne)",
		"arp": "arapaho",
		"twi": "twi (aszanti)",
		"arn": "araukański",
		"bla": "siksika (język Czarnych Stóp)",
		"gem": "germańskie (inne)",
		"arg": "aragoński",
		"ces": "czeski",
		"arc": "aramejski",
		"ypk": "jupik, języki",
		"arb": "arabski",
		"ara": "arabski",
		"cel": "celtyckie (inne)",
		"ceb": "cebuański (cebuano)",
		"tvl": "tuvalu",
		"yor": "joruba",
		"scs": "north slavey",
		"sco": "szkocki",
		"scn": "sycylijski",
		"ipk": "inupiak",
		"vie": "wietnamski",
		"tut": "ałtajskie (inne)",
		"niu": "niue",
		"epo": "esperanto",
		"tur": "turecki",
		"tup": "tupi, języki",
		"oci": "prowansalski (oksytański)",
		"tum": "tumbuka",
		"tuk": "turkmeński",
		"pus": "paszto (pusztu)",
		"zho": "chiński (mandaryński)",
		"mos": "mossi (mooré)",
		"mon": "mongolski",
		"lus": "lushai",
		"fiu": "ugrofińskie (inne)",
		"nic": "nigero-kongijskie (kongo-kordofańskie) (inne)",
		"nia": "nias",
		"moh": "mohawk",
		"luo": "luo (Kenia i Tanzania)",
		"lun": "lunda",
		"apa": "apaczeańskie (języki Apaczów)",
		"zha": "zhuang",
		"fin": "fiński",
		"jid": "bu",
		"fil": "filipiński (pilipino)",
		"lui": "luiseno",
		"fij": "fidżyjski",
		"bis": "bislama",
		"lug": "ganda",
		"hup": "hupa",
		"hun": "węgierski",
		"bin": "bini",
		"lub": "luba-katanga",
		"szw": "sawai",
		"lua": "luba-lulua (kasai)",
		"bik": "bikol",
		"und": "nieokreślony",
		"was": "washo",
		"war": "warajski (waray-waray)",
		"bih": "biharskie (inne)",
		"dun": "dusun deyah",
		"ltz": "luksemburski",
		"dum": "średnioniderlandzki (ok. 1050-1350)",
		"mno": "manobo, języki",
		"wal": "wolayta",
		"sat": "santali",
		"szl": "śląski",
		"wak": "wakasz, języki",
		"bia": "Badimaya",
		"sas": "sasak",
		"kbd": "kabardyjski",
		"mni": "manipuri (meithei)",
		"san": "sanskryt",
		"sam": "samarytański",
		"dua": "duala",
		"sal": "salisz, języki",
		"mnc": "mandżurski",
		"sai": "Indian południowoamerykańskich (inne)",
		"kaz": "kazachski",
		"sah": "jakucki",
		"sag": "sango",
		"kaw": "kawi",
		"inh": "inguski",
		"gba": "gbaya",
		"sad": "sandawe",
		"kau": "kanuri",
		"kat": "gruziński",
		"ine": "indoeuropejskie (inne)",
		"bho": "bhodźpuri",
		"kas": "kaszmirski",
		"ind": "indonezyjski",
		"enm": "średnioangielski (1100-1500)",
		"kar": "kareńskie",
		"inc": "indoaryjskie (inne)",
		"tso": "tsonga",
		"tsn": "tswana",
		"ina": "interlingwa (Międzynarodowy Język Pomocniczy)",
		"gay": "gayo",
		"kan": "kannada",
		"kam": "kamba",
		"eng": "angielski",
		"anp": "angika",
		"syr": "syryjski",
		"umb": "umbundu",
		"kal": "kalaallisut (grenlandzki)",
		"tsi": "tsimshian",
		"end": "ende",
		"enc": "en",
		"ang": "staroangielski (ok. 450-1100)",
		"kac": "kachin",
		"cau": "kaukaskie (inne)",
		"kab": "kabylski",
		"cat": "kataloński",
		"kaa": "karakałpacki",
		"car": "carib",
		"syc": "syryjski klasyczny",
		"gaa": "ga",
		"cai": "Indian środkowoamerykańskich (inne)",
		"cad": "kaddoskie",
		"mlt": "maltański",
		"zen": "zenaga",
		"hsb": "górnołużycki",
		"pro": "staroprowansalski (do1500)",
		"amh": "amharski",
		"cym": "walijski",
		"au": "australijski",
		"ven": "venda",
		"dsb": "dolnołużycki",
		"mlg": "malgaski",
		"ilo": "ilokano",
		"elx": "elamicki",
		"hrv": "chorwacki",
		"ukr": "ukraiński",
		"pra": "prakryty",
		"new": "newarski",
		"qaa-qtz": "Zarezerwowane dla lokalnego użytku",
		"ile": "interlingwe (język sztuczny)",
		"ell": "grecki nowożytny (nowogrecki) (po 1453)",
		"alt": "ałtajski",
		"nep": "nepalski",
		"iku": "inuktitut",
		"alg": "algonkińskie (inne)",
		"ale": "aleucki",
		"mkh": "mon-khmerskie (inne)",
		"swe": "szwedzki",
		"dra": "drawidyjskie (inne)",
		"mkd": "macedoński",
		"swa": "suahili",
		"ber": "berberskie (inne)",
		"nds": "dolnoniemiecki",
		"ben": "bengalski",
		"bem": "bemba",
		"bel": "białoruski",
		"ndo": "ndonga",
		"bej": "bedża",
		"tpi": "neomelanezyjski (tok pisin)",
		"unknown": "nieznany"
	},
	"global": {
		"title": "Tytuł",
		"subject": "Temat",
		"language": "Język",
		"place_of_publishing": "Miejsce wydawania",
		"data_provider": "Dostawca danych",
		"issue_period": "Okres wydawania",
		"date_filter": "Zakres dat",
		"count": "Liczba numerów w FBC",
		"license": "Licencja",
		"publisher": "Wydawca",
		"keywords": "Słowa kluczowe",
		"show_FBC": "Pokaż w FBC",
		"button": {
			"submit": "Zatwierdź",
			"apply": "Zastosuj",
			"cancel": "Anuluj",
			"close": "Zamknij",
			"totop": "Powrót do góry"
		}
	},
	"header": {
		"contrast": "Zmień kontrast",
		"font": "Zmień rozmiar czcionki",
		"lang": "Zmień język",
		"logo": "Powrót na stronę główną"
	},
	"footer": {
		"text": {
			"first": "Serwis FBC Czasopisma utrzymywany jest przez",
			"second": "i jest usługą świadczoną w ramach sieci",
			"PSNC": {
				"full": "Poznańskie Centrum Superkomputerowo-Sieciowe",
				"short": "PCSS",
				"link": "http://www.man.poznan.pl/online/pl/"
			},
			"PIONIER": {
				"full": "Polski Internet Optyczny PIONIER",
				"short": "PIONIER",
				"link": "http://www.pionier.net.pl/online/pl/"
			}
		},
		"menu": {
			"link_1": {
				"title": "FBC",
				"link": "https://fbc.pionier.net.pl/"
			},
			"link_2": {
				"title": "Z kim współpracujemy",
				"link": "http://fbc.pionier.net.pl/pro/zrodla"
			},
			"link_3": {
				"title": "Przyłącz się do FBC",
				"link": "http://fbc.pionier.net.pl/pro/wspolpraca/dla-dostawcow-danych/"
			},
			"link_4": {
				"title": "FBC na Facebooku",
				"link": "https://www.facebook.com/FederacjaBibliotekCyfrowych"
			},
			"link_5": {
				"title": "Kontakt",
				"link": "http://fbc.pionier.net.pl/pro/kontakt/"
			}
		}
	},
	"cookies": {
		"bar": {
			"text": "Używamy plików cookies, by ułatwić korzystanie z naszych serwisów. Jeżeli nie chcesz, by pliki cookies były zapisywane na Twoim dysku, zmień ustawienia swojej przeglądarki.",
			"link": "Sprawdź informacje o plikach cookies i polityce prywatności."
		},
		"modal": {
			"title": "Pliki cookies na naszych stronach",
			"text": "<p>Cookies to małe pliki tekstowe zapisywane na komputerze Użytkownika lub innym urządzeniu mobilnym, w czasie korzystania przez niego ze stron internetowych. Pliki te służą m.in. korzystaniu z różnych funkcji przewidzianych na danej stronie Internetowej lub potwierdzeniu, że dany Użytkownik widział określone treści z danej witryny Internetowej.</p><p>Niniejszy serwis internetowy może używać plików \"cookies\", kiedy użytkownik odwiedza stronę www. Pliki \"cookies\", które mogą zostać użyte w witrynach i stronach internetowych są kojarzone wyłącznie z przeglądarką konkretnego komputera (użytkownik anonimowy), bez podawania imienia lub nazwiska użytkownika. Są to informacje zapisywane przez serwer usługi WWW na komputerze użytkownika, które tenże serwer może odczytać przy każdorazowym połączeniu się z komputera użytkownika.</p><p>Pliki \"cookies\" dostarczają danych statystycznych o ruchu użytkowników i korzystaniu przez nich z poszczególnych stron serwisu; w niektórych przypadkach ich użycie jest niezbędne do poprawnego funkcjonowania usług udostępnianych przez serwis internetowy.</p><p>Użytkownik może w każdym czasie wybrać sposób obsługi plików \"cookies\" w strefie internetowej poprzez zastąpienie automatycznej obsługi plików \"cookie\" na obsługę indywidualną (ustawienia użytkownika). Szczegółowych informacji w tym zakresie udzielają dostawcy programów do obsługi strefy internetowej (przeglądarek), zazwyczaj w zakładce \"opcje internetowe\" lub podobnej. Jednakże wyłączenie przez użytkownika w swojej przeglądarce opcji akceptowania plików \"cookies\", (zablokowanie, monitowanie) może spowodować utrudnienia czy wręcz uniemożliwić korzystanie z niektórych usług internetowych.</p><p>Jednocześnie informujemy, że właściciele serwisu nie ponoszą żadnej odpowiedzialności za stosowanie lub obsługę plików \"cookies\" na innych stronach internetowych dostępnych dla użytkowników poprzez linki umieszczone w naszym serwisie.</p><p>Więcej informacji o plikach cookies znajdziesz w serwisie <a href=\"http://wszystkoociasteczkach.pl\" target=\"_blank\">http://wszystkoociasteczkach.pl/</a>.</p><p><strong>Copyright © 2017 PCSS</strong></p>"
		}
	},
	"altimg": {
		"logo": "Logotyp FBC Czasopisma"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/locals_pl.json
// module id = 210
// module chunks = 1